// 決定成功頁（/:pid/success）要顯示哪一版卡片：
// - 指定 pid（PID_BRANDS）優先，例：P261001173030262 → 慢跑墊卡片
// - 作者為 DKABio（creator CAeIG98z5）的其他問卷 → DKABio 公版卡片
// - 其他問卷 → EZChoice 公板（回傳 null）
// creator 只在進問卷時拿得到，由 useConvertSurvey 記在 sessionStorage，
// navigate 到成功頁、或在成功頁重新整理都還讀得到。

export const DKABIO_CREATOR = 'CAeIG98z5'

const PID_BRANDS = {
  P261001173030262: 'dkabio-jogging',
}

const normalizePid = (pid) => String(pid || '').toUpperCase()
const keyOf = (pid) => `ezc_success_brand_${normalizePid(pid)}`

export const saveSuccessBrand = (pid, creator) => {
  try {
    if (creator === DKABIO_CREATOR) {
      sessionStorage.setItem(keyOf(pid), 'dkabio')
    } else {
      sessionStorage.removeItem(keyOf(pid))
    }
  } catch (e) {
    // 隱私模式等情況拿不到 storage，退回公板
  }
}

export const getSuccessBrand = (pid) => {
  const pidBrand = PID_BRANDS[normalizePid(pid)]
  if (pidBrand) return pidBrand
  try {
    return sessionStorage.getItem(keyOf(pid))
  } catch (e) {
    return null
  }
}
